import { lazy } from "react";
import { ADMIN_TAB_PAGES } from "@/lib/tabs/pageDescriptorsAdmin";
import { SHARED_TAB_PAGES } from "@/lib/tabs/pageDescriptorsShared";
import { USER_TAB_PAGES } from "@/lib/tabs/pageDescriptorsUser";

export const TAB_PAGES = {
  ...SHARED_TAB_PAGES,
  ...USER_TAB_PAGES,
  ...ADMIN_TAB_PAGES,
};

export const pageRegistry = TAB_PAGES;

const lazyPageCache = new Map();

const UnknownPage = ({ type }) => <div>Unknown page: {type}</div>;

export const resolvePageDescriptor = (type) => pageRegistry[type] || null;

export const resolvePage = (type) => {
  const descriptor = resolvePageDescriptor(type);
  if (!descriptor) {
    return () => <UnknownPage type={type} />;
  }

  if (!lazyPageCache.has(type)) {
    lazyPageCache.set(type, lazy(descriptor.loadPage));
  }

  return lazyPageCache.get(type);
};
